import React from 'react';
import PropTypes from 'prop-types';

const CsvPreviewWidget = props => (
  <div style={{ overflow: 'scroll' }}>
    {props.value &&
      props.value.length === 0 && (
        <div>
          <i>Please load a xlsx or csv file</i>
        </div>
      )}
    <table className="border">
      <thead>
        {props.value &&
          props.value.length > 0 && (
            <tr>
              {Object.keys(props.value[0]).map(key => (
                <th key={`th${key}`}>{key}</th>
              ))}
            </tr>
          )}
      </thead>
      <tbody>
        {props.value &&
          props.value.length > 0 &&
          props.value.map((item, index) => (
            <tr key={`tr_${index}`}>
              {Object.values(item).map((value, index) => (
                <td key={`td_${index}`}>{value}</td>
              ))}
            </tr>
          ))}
      </tbody>
    </table>
  </div>
);
CsvPreviewWidget.propTypes = {
  value: PropTypes.arrayOf(PropTypes.object)
};

export default CsvPreviewWidget;



// WEBPACK FOOTER //
// ./src/components/CsvPreviewWidget.js